import { apiFetchMutiCouponList } from '@/api/imee'

export const mixin = {
  data() {
    return {
      scene: this.$route.query.scene || null,

      // 优惠券
      maxCoupon: null,
      showCoupons: false,
      selectedCoupon: null,
      validCouponList: [],

      // 支付结果
      showResultDia: false,
      payResultText: ''
    }
  },
  methods: {
    // 跳转客服页面
    goCustomer() {
      this.appAction('open_customer_service_page', '')
    },
    // prettier-ignore
    getShopType () {
      // 获取shopType
      if (this.$route.query.shopType) {
        return this.$route.query.shopType
      }
      else {
        return this.scene == 'activity' ? 7 : null
      }
    },
    // 支付结果-客户端回调
    onNewIntent(url) {
      if (url) {
        let data = JSON.parse(url)
        if (data.status == 'PENDING') {
          this.payResultText = this.$t('lang.BaseCommon.k090')
          this.showResultDia = true
        }
        if (data.status == 'FAILED') {
          this.payResultText = this.$t('lang.BaseCommon.k089')
          this.showResultDia = true
        }
        if (data.status == 'CLOSED') {
          this.payResultText = 'Closed'
          this.showResultDia = true
        }
      }
    },

    // 支付结果-关闭弹窗
    cancelAgain() {
      this.showResultDia = false
    },

    initCoupon() {
      this.resetCoupon()

      // 初始化优惠券列表
      if (this.scene != 'activity') {
        const coinAmount = this.myPlus(this.amount, this.presentAmount)
        apiFetchMutiCouponList({ coinAmount }).then((resData) => {
          if (resData) {
            // 有效的
            this.validCouponList = resData.validCouponRecords || []
            this.findMaxCoupon(this.validCouponList, true)
          }
        })
      }
    },

    resetCoupon() {
      this.maxCoupon = null
      this.showCoupons = false
      this.selectedCoupon = null
      this.validCouponList = []
    },

    // 优惠券-找最优
    findMaxCoupon(couponList, useMax) {
      try {
        if (couponList && couponList.length) {
          const tempCoupon = couponList[0]
          if (tempCoupon.canUse === true) {
            this.maxCoupon = tempCoupon
            if (useMax) {
              this.selectedCoupon = tempCoupon
            }
          }
          //
          else {
            this.maxCoupon = null
            if (useMax) {
              this.selectedCoupon = null
            }
          }
        }
      } catch (err) {
        console.log('try catch err', err)
      }
    },

    // 优惠券-打开列表
    handleClickCouponEnter() {
      if (this.showCoupons) {
        this.showCoupons = false
        return
      }

      const hasCoupon = this.validCouponList && this.validCouponList.length
      if (hasCoupon) {
        const nowTime = Date.now()
        this.validCouponList.forEach((item) => {
          if (nowTime > item.expiredTime) {
            item.canUse = false
          }
        })

        this.validCouponList = this.validCouponList.filter((item) => item.canUse)

        if (this.selectedCoupon) {
          if (!this.validCouponList.some((couponItem) => couponItem.couponRecordId === this.selectedCoupon.couponRecordId)) {
            this.selectedCoupon = null
          }
        }
      }

      this.showCoupons = this.validCouponList && this.validCouponList.length
    },

    // 优惠券-选择
    handleSelectCoupon(item) {
      if (item && item.canUse === true) {
        this.selectedCoupon = item
      }
    },

    // 支付方式-选谷歌/apple支付
    selectOriginPay() {
      if (this.googlePrice) {
        this.handleSelectPay(
          {
            currency: this.googleCurrency,
            price: this.myTimes(this.googlePrice, 100),
            currencyPrice: this.googleCurrencyPrice
          },
          9999
        )
      }
    },

    // 支付方式-默认选最优
    selectedBestPayType() {
      if (this.payList.length) {
        const bestIndex = this.payList.findIndex((item) => item.ifBestPrice)
        if (bestIndex > -1) {
          this.handleSelectPay(this.payList[bestIndex], bestIndex)
        }
      }
    },

    // 支付方式排序
    sortPayType() {
      if (this.payList.length) {
        // 处理最优 和 上次使用
        let lastUsedChannelIndex = this.payList.findIndex((item) => item.name === this.lastUsedChannel)
        let lastUsedObj = null
        if (lastUsedChannelIndex > -1) {
          lastUsedObj = this.payList[lastUsedChannelIndex]
          lastUsedObj['lastUsed'] = true
          this.payList.splice(lastUsedChannelIndex, 1)
        }
        if (lastUsedObj) {
          this.payList.unshift(lastUsedObj)
        }

        let bestIndex = this.payList.findIndex((item) => item.ifBestPrice)
        let bestObj = null
        if (bestIndex > -1) {
          bestObj = this.payList[bestIndex]
          bestObj['best'] = true
          this.payList.splice(bestIndex, 1)
        }
        if (bestObj) {
          this.payList.unshift(bestObj)
        }
      }
    }
  },
  mounted() {
    window.onNewIntent = this.onNewIntent
  }
}
